// import TrainingInstallApp from
// 'modules/training/components/InstallApp'
import {
  EQUIPMENT,
  EQUIPMENT_MESSAGE,
  getOrderedEquipmentWorkoutUtil
} from '@gymaholic/packages'
// import ViewInApp from 'components/ViewInApp'
import formatMessageIntlUtil from 'modules/intl/utils/format-message'
// TRAINING_DEEP_LINKS_ROUTES
// } from
// 'modules/training/modules/deep-links/constants' import
// navigateTrainingDeepLinkUtil from
// 'modules/training/modules/deep-links/utils/navigate'
import { defineMessages } from 'react-intl'

const messages = defineMessages({
  valueAndMorePlus: {
    id: 'getEquipmentStrWorkoutUtil.valueAndMorePlus',
    defaultMessage: '{value} +'
  }
})

export default function getEquipmentStrWorkoutUtil ({
  intl,
  workout
}) {
  const equipment = getOrderedEquipmentWorkoutUtil(workout)
  const equipmentWithoutBodyweight = equipment.filter(equipmentItem => equipmentItem !== EQUIPMENT.BODYWEIGHT)
  const equipmentCount = equipmentWithoutBodyweight.length

  if (equipmentCount === 0) {
    return formatMessageIntlUtil(
      intl,
      EQUIPMENT_MESSAGE[EQUIPMENT.BODYWEIGHT]
    )
  }

  if (equipmentCount === 1) {
    return formatMessageIntlUtil(
      intl,
      EQUIPMENT_MESSAGE[equipmentWithoutBodyweight[0]]
    )
  }

  const equipmentMessage = formatMessageIntlUtil(
    intl,
    EQUIPMENT_MESSAGE[equipmentWithoutBodyweight[0]]
  )
  return formatMessageIntlUtil(intl, messages.valueAndMorePlus, {
    value: equipmentMessage
  })
}
